export enum AuditRequestRoutes {
  EXPORT_AUDIT_HISTORY = "/api/admin/audit-history/export",
}

export enum AuditHistoryPageErrors {
  DOWNLOAD_EXPORT_AUDIT_HISTORY = "An error occurred when attempting to export Audit History.",
}
